export type Environment = 'tst' | 'acc' | 'prd'

export const API_BASE_URL: Record<Environment, string> = {
  tst: 'https://tst.appointment.suitsupply.com/api',
  acc: 'https://acc.appointment.suitsupply.com/api',
  prd: 'https://appointment.suitsupply.com/api',
}

export const INSTRUMENTATION_KEY: Record<Environment, string> = {
  tst: 'a0803054-0e31-48bf-ae04-1e3abd87e197',
  acc: '38f2b37f-7203-46e8-becc-60fee272381b',
  prd: '6c512b76-d41c-437d-8f9c-a6fba70fc9da',
}

export const DATADOG_CONFIG = {
  applicationId: 'fbb76532-aa47-40ef-8f9f-af5513bc42eb',
  clientToken: 'pub37a8ba200c075d0c76b2a19049602f7f',
  service: 'booking-tool',
  platform: 'instore',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 5,
} as const

export const GROWTHBOOK_CLIENT_KEY: Record<Environment, string> = {
  tst: 'sdk-QJuaoobMsTbl4Xy',
  acc: 'sdk-3RHhusOm4TMqnpv8',
  prd: 'sdk-8TP0RBlivw2TPxD',
}

export const GROWTHBOOK_API_HOST = 'https://cdn.growthbook.io'

/**
 * When on, entering the flow picks "No preference" for the visitor instead of
 * showing the style-advisor screen. The screen itself stays in the tool and
 * stays reachable from "See all style advisors".
 *
 * **Which stores it applies to is GrowthBook's business, not this code's** — the
 * flag's own rule targets the `locationCode` attribute that
 * `FeatureFlagsProvider` sends (Amsterdam, `SR-NL-Amsterdam-Willemsparkweg`, at
 * the time of writing). Adding a store is a rule change, not a deploy; do not
 * reintroduce a store list here.
 *
 * Key follows ADR-08 (`<APP_PREFIX>-<feature-description>`); `RP` is Retail &
 * Personal Styling, and the flag carries the `IT-RP` tag in GrowthBook.
 */
export const SKIP_STYLE_ADVISOR_SELECTION_FLAG =
  'RP-skip-styleadvisor-selection'

/** Default Waitwhile service ID used when no specific service has been selected. */
export const DEFAULT_WAITWHILE_SERVICE_ID: Record<Environment, string> = {
  tst: 'NxObOQmpbtw8LJNsNc7H',
  acc: 'NxObOQmpbtw8LJNsNc7H',
  prd: 'M7eqRWLNEAIfFAxr0jmz',
}

/** Storefront base URLs per environment — used for post-reschedule redirect to store page. */
export const STOREFRONT_BASE_URL: Record<Environment, string> = {
  tst: 'https://testing.suitsupply.com',
  acc: 'https://acceptance.suitsupply.com',
  prd: 'https://suitsupply.com',
}

/** Employee Profile Page (EPP) base URLs per environment. */
export const EPP_URL: Record<Environment, string> = {
  tst: 'https://tst.expert.suitsupply.com/v2/',
  acc: 'https://acc.expert.suitsupply.com/v2/',
  prd: 'https://expert.suitsupply.com/v2/',
}

/** UTM params appended to EPP links to track booking-tool traffic. */
export const EPP_UTM =
  '?utm_source=storepage&utm_medium=bookingtool&utm_campaign=employee'

export const NO_PREFERENCE_IMAGE =
  'https://cdn.suitsupply.com/image/upload/w_400,h_400,f_auto,q_auto/employeeimages/noprefavatar1.png'

export const WE_CHAT_CONTACT = '40082 05572'

/**
 * Delay on the intermediate "Appointment confirmed" screen before navigating
 * to pre-appointment-purpose (matches legacy booking-tool).
 */
export const PRE_APPOINTMENT_REDIRECT_MS = 1500
